module.exports = __webpack_public_path__ + "static/media/connection-implants-spanish.bcc28f6a.png";